/** @module csi/widget/FIStateDropDown */
define([
	"dojo/_base/declare",
	"dijit/form/DropDownButton",
	"dijit/MenuItem",
	"csi/access/crews",
	"csi/locale",
	"csi/html",
	"csi/widget/DropDownMenu",
	"csi/xml",
	"dojo/text!./FIStateDropDown.html"
], function(declare, DropDownButton, MenuItem, crews, locale, html, DropDownMenu, xml, template){

	return declare(DropDownButton, {
		templateString: template,

		/** @property {DOMNode} _aroundNode - internal dojo framework node that acts as an anchor for dropdown popup */
		_aroundNode: null,

		/** @property {string[]} _inspectionAdminEditorRoles - Inspection Admin / Editor Roles required for dropdown use */
		_inspectionAdminEditorRoles: ["Inspection Administrator", "Inspection Editor"],

		/** @property {DOMNode} caretNode - node for Font Awesome's caret down */
		caretNode: null,

		/** @property {String} css - css string for styling of button */
		css: null,

		/** @property {DOMNode} focusNode - focus node for dropdown */
		focusNode: null,

		/** @property {DOMNode} iconNode - needed for dojo framework to add nodijiticon class */
		iconNode: null,
		
		/** @property {DOMNode} labelNode - label node for pill button */
		labelNode: null,

		/** @property {string[]} menuItems - array for menu items, post create will add these on */
		menuItems: [],

		/** @property {string[]} node - current view node (either FinalInspection or FinalInspectionBatch) */
		node: null,

		/** @property {string} batchString - will equal "Batch" if node is batch level, "" otherwise */
		batchString: "",

		/** @property {string} STATE_FAILED - InspectionBatchState:Failed */
		STATE_FAILED: "Failed",

		/** @property {string} STATE_IN_PROGRESS - InspectionBatchState:InProgress */
		STATE_IN_PROGRESS: "InProgress",

		/** @property {string} STATE_IN_PASSED - InspectionBatchState:Passed */
		STATE_PARTIALLY_PASSED: "PartiallyPassed",

		/** @property {string} STATE_IN_PASSED - InspectionBatchState:Passed */
		STATE_PASSED: "Passed",

		/** @property {string} stateEnumValue - current state enum value */
		stateEnumValue: null,

		/**
		 * Return whether user has access to dropdown
		 * @param {C8Node} node - node to check
		 */
		_hasAccess: function(node) {
			return !xml.nodeIsFrozen(node) && xml.nodeHasRight(node, xml.RIGHT_WRITE) && crews.isInRoles(this._inspectionAdminEditorRoles, node);
		},

		/**
		 * DropDown selection extension point
		 */
		dropDownSelect: function(selection) { },

		/*
		 * Dojo internal postCreate lifecycle function.
		 */
		postCreate: function() {
			const {
				batchString,
				caretNode,
				css,
				domNode,
				dropDownSelect,
				focusNode,
				labelNode,
				menuItems,
				node,
				stateEnumValue,
				STATE_FAILED,
				STATE_IN_PROGRESS,
				STATE_PARTIALLY_PASSED,
				STATE_PASSED,
			} = this;

			// if state is in progress and view node is not frozen, show cursor as pointer
			const { style } = focusNode;
			if (stateEnumValue === STATE_IN_PROGRESS && this._hasAccess(node)) {
				style.cursor = "pointer";
			} else {
				style.cursor = "";
			}

			// if state is passed, failed, or partially passed, hide dropdown caret, otherwise show it
			if (stateEnumValue !== STATE_PASSED && stateEnumValue !== STATE_FAILED && stateEnumValue !== STATE_PARTIALLY_PASSED) {
				caretNode.classList.remove(html.CSS_HIDE);

				// text content is "PASS / FAIL ▼"
				labelNode.textContent = `${locale.resource("PassInspection").toUpperCase()} / ${locale.resource("FailInspection").toUpperCase()}`;
			} else {
				caretNode.classList.add(html.CSS_HIDE);

				domNode.querySelector(".PassOrFail").classList.add(...css.split(" "));

				// text content is either "PASSED", "PARTIALLY PASSED", or "FAILED"
				labelNode.textContent = locale.getEnumName(`Inspection${batchString}State:${stateEnumValue}`, true);
			}

			// create dropdown menu
			this.dropDown = new DropDownMenu();
			const { dropDown } = this;
			menuItems.forEach((item) => {
				const newItem = new MenuItem({
					label: item,
				});
				// remove empty arrow cell node
				newItem.focusNode.lastElementChild.remove();
				dropDown.addChild(newItem);
			});
			dropDown.startup();
			dropDown.onItemClick = dropDownSelect.bind(this);
		},

		/**
		 * Click event for DropDown Button.
		 * @param {MouseEvent} e
		 */
		_onClick: function(e) {
			if (this.stateEnumValue === this.STATE_IN_PROGRESS && this._hasAccess(this.node)) {
				const { _popupWrapper } = this.dropDown;
				// pre-show the wrapper so width is exposed
				html.setVisible(_popupWrapper, true);
				// get width of button
				const buttonWidth = this.domNode.offsetWidth;
				// set the delta of the button to be the difference of the dropdown and button width divided by two
				const delta = (_popupWrapper.offsetWidth - buttonWidth) / 2;
				if (delta > 0) {
					// if delta is great than 0, e.g., if the dropdown width is bigger, pull it to the left to center it
					html.setPixels(this._aroundNode, html.LEFT, -delta);
				} else {
					// if the dropdown is smaller, set the width of the table element in the dropdown to match, in this case the first child of the popup wrapper.
					html.setPixels(_popupWrapper.firstChild, html.WIDTH, buttonWidth);
				}
				this.toggleDropDown();
			}
		},
	});
});
